import {
  MarkerClusterer,
  SuperClusterAlgorithm,
} from "@googlemaps/markerclusterer";

interface CreateClustererOptions {
  map: google.maps.Map;
  markers: google.maps.marker.AdvancedMarkerElement[];
}

export const createClusterer = ({
  map,
  markers,
}: CreateClustererOptions): MarkerClusterer => {
  return new MarkerClusterer({
    map,
    markers,
    algorithm: new SuperClusterAlgorithm({
      maxZoom: 19,
      gridSize: 60,
    }),
    renderer: {
      render: ({ count, position }) => {
        const size = Math.min(count * 5 + 20, 50);

        const element = document.createElement("div");
        element.style.width = `${size}px`;
        element.style.height = `${size}px`;
        element.style.borderRadius = "50%";
        element.style.background = "#0b264c";
        element.style.display = "flex";
        element.style.alignItems = "center";
        element.style.justifyContent = "center";
        element.style.color = "white";
        element.style.fontSize = `${Math.min(size / 2, 16)}px`;
        element.style.border = "2px solid white";
        element.textContent = String(count);

        return new google.maps.marker.AdvancedMarkerElement({
          position,
          content: element,
        });
      },
    },
  });
};

export const clearClusterer = (clusterer: MarkerClusterer | null) => {
  if (clusterer) {
    clusterer.clearMarkers();
  }
};
